import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IPresentationType} from "../interfaces/ipresentationType";
import { PresentationTypeService } from "../services/presentationtype.service";
import { Observable } from "rxjs";

@Injectable()
export class PresentationTypeResolver implements Resolve<IPresentationType[]> {

    constructor(private presentationTypeService: PresentationTypeService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IPresentationType[]> {
        return this.presentationTypeService.getAll();
    }
}
